<template>
  <el-dialog
    v-drag
    title="审核"
    :visible.sync="dialogVisible"
    width="506px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <div class="btn">
        <div :class="['flex_c_c', !active && 'active']" @click="confirm(0)">系统自动合并</div>
        <div :class="['flex_c_c', active && 'active']" @click="confirm(1)">手动合并</div>
      </div>
      <el-form
        v-if="active === 0"
        ref="form"
        class="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <div class="row">
          <el-form-item label="品名数量" prop="quantity">
            <el-input-number
              v-model="form.quantity"
              style="width: 100%"
              controls-position="right"
              :min="1"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
          <el-form-item label="最小税金" prop="taxAmountMin">
            <el-input-number
              v-model="form.taxAmountMin"
              style="width: 100%"
              controls-position="right"
              :min="1"
              :step="2"
            >
            </el-input-number>
          </el-form-item>
          <el-form-item label="最大税金" prop="taxAmountMax">
            <el-input-number
              v-model="form.taxAmountMax"
              style="width: 100%"
              controls-position="right"
              :min="1"
              :step="2"
            >
            </el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <!-- <div :style="{'visibility': !active ? 'visible' : 'hidden'}">
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :file-list="fileList"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <svg-icon iconClass="upload" className="icon" />
          <p class="el-upload__text">将文件拖到此处</p>
          <p class="el-upload__text">或</p>
          <div class="btn flex_c_c">选择文件</div>
        </el-upload>
        <div v-if="fileList.length" class="fileList">
          <div class="progress">
            <el-progress
              type="circle"
              :width="40"
              :height="40"
              :stroke-width="4"
              :percentage="porgress"
            ></el-progress>
          </div>
          <div class="file">
            <p v-tooltip="166" class="fileName">{{ fileList[0]?.fileName }}</p>
            <p class="fileSize">{{ fileList[0]?.fileSize }} mb</p>
          </div>
          <div class="opt">
            <i class="el-icon-delete" title="删除" @click="deleteFile" />
          </div>
        </div>
      </div> -->
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-loading="loading" class="ok flex_c_c" @click="ok('form')">确定</div>
    </span>
  </el-dialog>
</template>

<script>
import { mergeMainifestSystem, readMainifest } from '@/api/bill'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      tpye: Object,
      default: () => {}
    }
  },
  data() {
    return {
      active: 0,
      loading: false,
      form: {
        quantity: '',
        taxAmountMax: '',
        taxAmountMin: ''
      },
      rules: {
        quantity: [{ required: true, message: '请输入条目', trigger: 'change' }],
        taxAmountMax: [{ required: true, message: '请输入最大税金', trigger: 'change' }],
        taxAmountMin: [{ required: true, message: '请输入最小税金', trigger: 'change' }]
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
        this.reset()
    },
    confirm(type) {
      this.active = type
    },
    reset() {
      this.active = 0
      this.form = {
        quantity: ''
      }
    },
    async ok(formName) {
      if (!this.active) {
          this.$refs[formName].validate(async(valid) => {
          if (valid) {
            if (+this.form.taxAmountMin >= +this.form.taxAmountMax) {
              this.$message.error('最小税金不能大于等于最大税金')
              return
            }
            const params = {
              ...this.form,
              mblId: this.rowData.id
            }
            try {
              this.loading = true
              const res = await mergeMainifestSystem(params)
              this.loading = false
              if (res.success) {
                this.$message.success('操作成功')
                this.$emit('ok', res.data)
                this.$refs[formName]?.resetFields()
              } else {
                this.$message.error(res.errorMessage)
              }
            } catch (error) {
              console.log(error)
            }
          }
        })
      } else {
        const params = {
              mblId: this.rowData.id
            }
            try {
              this.loading = true
              const res = await readMainifest(params)
              this.loading = false
              if (res.success) {
                this.$message.success('操作成功')
                this.$emit('ok', res.data)
                this.$refs[formName]?.resetFields()
              } else {
                this.$message.error(res.errorMessage)
              }
            } catch (error) {
              console.log(error)
            }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 86px);
  margin: 0 auto;
  & > .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
    overflow: hidden;
    & > div {
      width: 50%;
      height: 40px;
      background: #ffffff;
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      border: 1px solid #eeeeee;
      box-sizing: border-box;
      cursor: pointer;
      & + div {
        border-left: 0;
      }
      &.active {
        color: #FFFFFF;
        background:  rgb(18,88,188);
      }
    }
  }
  .upload-demo {
    width: 100%;
    height: 200px;
    margin-top: 10px;
    .btn {
      width: 120px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid  rgb(18,88,188);
      margin: 10px auto 0;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
    }
    .icon {
      font-size: 40px;
      color:  rgb(18,88,188);
      margin-top: 24px;
    }
  }
  &:deep(.el-upload) {
    width: 100%;
    height: 200px;
  }
  &:deep(.el-upload-dragger) {
    width: 100%;
    height: 200px;
  }
  &:deep(.el-upload-dragger) {
    background: #f7f7f7;
  }
  &:deep(.el-upload__text) {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    margin-top: 10px;
  }
  .fileList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 64px;
    box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.1);
    border-radius: 6px 6px 6px 6px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-top: 10px;
    & > div {
      line-height: normal;
    }
    .progress {
      width: 40px;
      height: 40px;
    }
    .file {
      width: 280px;
      .fileName {
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .fileSize {
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
    }
    .opt {
      .el-icon-delete {
        font-size: 24px;
        color: #cdcdcd;
        cursor: pointer;
      }
    }
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & div {
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
    margin-right: 16px;
  }
  .ok {
    background:  rgb(18,88,188);
    color: #ffffff;
  }
}
</style>
